// extracted by mini-css-extract-plugin
export default {"dialog--inner":"Zhub6As2G8K096eKKMVX0zRHq2LQxOh+6vJHlbaFA-o="};